import { configService } from "../index";
import Cellar from "../../models/cellar";
import { BaseRequests } from "./BaseRequests";
import { BaseRequestsInterface } from "./BaseRequests";

export default {
  ...BaseRequests(
    () => configService.cellars,
    "company",
    () => new Cellar()
  )
} as BaseRequestsInterface;
